module.exports = __webpack_public_path__ + "img/2.d1c9dc59.png";